var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main",staticStyle:{"margin-top":"60px"}},[_c('CampaignDetailIframe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }